import { useContext } from "react";
import { useLatestQuery } from "../../../WSUtils/useLatestQuery";
import { UserInfoContext } from "../../../WSUtils/UserInfoContext";
import { sentryAssertData } from "../../../WSUtils/wsSentry";
import { getQuestionFormToken } from "./getQuestionFormToken";

export const useQuestionFormLog = (questionFormId: number) => {
  const userInfo = useContext(UserInfoContext);
  const questionFormAPI = userInfo.fullAPI.questionFormAPI;
  const token = getQuestionFormToken();

  const { data: forms } = useLatestQuery(
    ["questionFormsAPI.getQuestionFormLogs", questionFormId],
    () =>
      questionFormAPI.getQuestionFormLogs({
        userInfo: userInfo,
        formId: questionFormId,
        questionId: null,
        questionOptionId: null,
      }),
    { enabled: !token }
  );

  const { data: anonymousForm } = useLatestQuery(
    ["questionFormsAPI.getQuestionFormLogs", questionFormId],
    () =>
      questionFormAPI.getQuestionFormLogAnonymous({
        userInfo: userInfo,
        token,
      }),
    { enabled: !!token }
  );

  sentryAssertData([forms, anonymousForm], { userInfo });

  let qfl =
    anonymousForm?.item ??
    forms?.items?.find((x) => x.questionFormId == questionFormId);

  return {
    qfl,
    isDone: anonymousForm || forms,
    responses: [forms, anonymousForm],
  };
};
